import React, {useCallback, useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {BiShow, BiSolidEdit} from "react-icons/bi";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {useNavigate} from "react-router-dom";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FiFilter} from "react-icons/fi";
import OpsToast from "../../ops-library/ops-toast";
import formatDate from "../../functions/formatDate";
import {FaPlus} from "react-icons/fa";
import OpsTable from "../../ops-library/ops-table";
import OpsIconStatus from "../../ops-library/ops-icon-status";
import {TbRestore} from "react-icons/tb";
import {TagsInput} from "react-tag-input-component";

const AdminArticles = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [articles, setArticles] = useState(null)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalArticleShown, setModalArticleShown] = useState(false);
    const [loading, setLoading] = useState(true)
    const [loadingArticle, setLoadingArticle] = useState(false)

    const [modalData, setModalData] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!hasRoleAccess(sectionId, user.role))
            navigate("/")
        getArticles();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getArticles(showDeleted = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configuration)
            .then((result) => {
                setArticles(result.data.content)
                setLoading(false)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function patchArticle(id, data) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/${id}?includeDeleted=${showDeleted}`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setArticles(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    function restoreArticle(id) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/restore/${id}?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setArticles(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    // MODALS
    // ------------------------------------------------------------------------------
    function handleOpenModalArticle(data) {
        if (data) {
            setModalArticleShown(true);
            setModalData(data)
        } else {
            setModalArticleShown(true);
            setModalData(null);
        }
    }

    function handleModalsClose() {
        setModalArticleShown(false)
        setModalData(null)
    }

    const ModalArticle = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)
        const [title, setTitle] = useState(modalData?.title ?? "");
        const [subtitle, setSubtitle] = useState(modalData?.subtitle ?? "");
        const [tags, setTags] = useState(modalData?.tags ?? ["ĽH Beťarky"]);
        const [coverImg, setCoverImg] = useState(modalData?.coverImg ?? null);
        const [preview, setPreview] = useState(modalData?.coverImg ? `${process.env.REACT_APP_API_BASE_URL}/${modalData.coverImg}` : "");
        const [readTime, setReadTime] = useState(modalData?.readTime ?? 1);
        const [published, setPublished] = useState(modalData?.published ?? false);

        // API functions - patch/post/delete
        // ------------------------------------------------------------------------------
        async function patchArticle(id, data) {
            setProcessed(true)
            // Orezanie obrázka podľa výberu
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("subtitle", data.subtitle);
            formData.append("published", data.published);
            data.tags.forEach(tag => {
                formData.append('tags[]', tag);
            });
            if (data.coverImg) {
                formData.append("coverImg", data.coverImg);
            }

            const configuration = {
                method: "patch",
                url: `${process.env.REACT_APP_API_BASE_URL}/articles/${id}?includeDeleted=${showDeleted}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            };
            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setArticles(result.data.content)
                        OpsToast(result.data.message, "success")
                        handleModalsClose()
                    }
                })
                .catch((error) => {
                    opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        async function postArticle(data) {
            setProcessed(true)
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("subtitle", data.subtitle);
            formData.append("published", data.published);
            data.tags.forEach(tag => {
                formData.append('tags[]', tag);
            });
            if (data.coverImg) {
                formData.append("coverImg", data.coverImg);
            }

            const configuration = {
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/articles?includeDeleted=${showDeleted}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setArticles(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function deleteArticle(id) {
            setProcessed(true)
            const configuration = {
                method: 'delete',
                url: `${process.env.REACT_APP_API_BASE_URL}/articles/${id}?includeDeleted=${showDeleted}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setArticles(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                setCoverImg(file);
                setPreview(URL.createObjectURL(file));
            }
        };

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={`${title}`}/>
                        <div className="fa-flex-row gap-2">
                            <OpsBtn
                                icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                                variant="icon me-2"
                                padding={false}
                                action={() => {
                                    const actual_article = modalData;
                                    handleModalsClose()
                                    opsConfirmDialog(
                                        "Vymazanie článku",
                                        `Naozaj si prajete odstrániť článok?`,
                                        theme,
                                        () => deleteArticle(actual_article._id),
                                        () => handleOpenModalArticle(actual_article)
                                    )
                                }}
                            />
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {!processed || !loadingArticle ?
                        <div className="custom-modal-content justify-content-between">
                            {/*HLAVICKA*/}
                            <div className="desktop-row-phone-col justify-content-between w-100 mb-2">
                                {modalData && <div className="fa-flex-col">
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Autor: ${modalData.author}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Upravené: ${formatDate(modalData.updatedAt, true)}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Vytvorené: ${formatDate(modalData.createdAt, true)}`}/>
                                </div>}
                                <div className="fa-flex-col align-items-end gap-1">
                                    <OpsText type="label" alignment="right" color="color-1"
                                             content={published ? 'Zrušiť zverejnenie' : 'Zverejniť'}/>
                                    <OpsInput customType="switch" checked={published}
                                              onChange={() => setPublished(!published)}
                                    />
                                </div>
                            </div>

                            {/*NAZOV A PODNAZOV*/}
                            <div className="fa-flex-col">
                                <OpsInput
                                    required
                                    id="title"
                                    label="Názov článku"
                                    placeholder="Zadajte názov pre článok s max. dĺžkou 60 znakov"
                                    maxLength={60}
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />

                                <OpsInput
                                    required
                                    customType="textarea"
                                    id="subtitle"
                                    label="Podnadpis"
                                    placeholder="Zadajte podnadpis pre článok s odporučanou dĺžkou 200 znakov"
                                    maxLength={800}
                                    value={subtitle}
                                    onChange={(e) => setSubtitle(e.target.value)}
                                />
                            </div>

                            {/*FOTOGRAFIE*/}
                            <div className="fa-flex-col gap-1 my-2">
                                <OpsText type="normal" alignment="left" color="color-1"
                                         content="Titulná fotografia článku"/>
                                <div className="desktop-row-phone-col fa-w-100 align-items-center">
                                    <OpsInput
                                        required
                                        id="coverImage"
                                        customType="imgUpload"
                                        componentClassName="fa-w-100"
                                        size="bg"
                                        value={preview}
                                        onChange={handleFileChange}
                                    />
                                </div>
                                {preview && (
                                    <img src={preview} className="adm-preset-img-3 object-fit-cover mt-2" alt=""/>
                                )}
                            </div>

                            {/*DLZKA CITANIA*/}
                            <OpsInput type="number" size="md" value={readTime}
                                      label="Dĺžka čítania (min.)"
                                      onChange={(e) => setReadTime(e.target.value)}
                            />


                            {/*TAGY*/}
                            <div className="fa-flex-col mb-4">
                                <label className='mt-2 pb-1 color-1 font-400'
                                       htmlFor='inp-tags'>{"Tagy pre článok"}</label>
                                <TagsInput
                                    id="inp-tags"
                                    name="tags"
                                    placeHolder="Pre potvrdenie tagu stlačte Enter"
                                    value={tags}
                                    onChange={setTags}
                                />
                            </div>

                            {/*CONTENT*/}
                            <div className="fa-flex-col my-4">
                                {modalData !== null ?
                                    <div className="fa-flex-row gap-3 align-items-center">
                                        <OpsText type="normal" color="color-1"
                                                 content="Obsah článku"/>
                                        <OpsBtn
                                            text="Upraviť"
                                            size="sm"
                                            action={() => navigate(`/admin/uprava-clanku/${modalData?._id}`)}
                                        />
                                    </div>
                                    :
                                    <OpsText type="normal" className="" color="color-1"
                                             content="Pre vytvorenie obsahu článku musíte najprv článok vytvoriť so všetkými jeho povinnými atribútmi!"/>
                                }
                            </div>
                            <div dangerouslySetInnerHTML={{__html: modalData?.content}}/>

                            <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                <OpsBtn
                                    text="Zahodiť"
                                    variant="secondary"
                                    size="md mt-2"
                                    action={() => handleModalsClose()}
                                />
                                <OpsBtn
                                    text="Uložiť"
                                    variant="primary"
                                    size="md mt-2"
                                    action={() => modalData !== null ? patchArticle(modalData?._id,
                                        {
                                            title: title,
                                            subtitle: subtitle,
                                            tags: tags,
                                            coverImg: coverImg,
                                            published: published,
                                        }
                                    ) : postArticle(
                                        {
                                            title: title,
                                            subtitle: subtitle,
                                            tags: tags,
                                            coverImg: coverImg,
                                            published: published,
                                        }
                                    )
                                    }
                                />
                            </div>

                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalArticle show={modalArticleShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="AKTUALITY"/>

            {/* SPRAVA CLANKOV */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Správa článkov"/>
                    <div className="fa-flex-row">
                        {/*VYTVORIT CLANOK<*/}
                        <OpsBtn
                            id="tbl-create"
                            tooltipText="Pridať článok"
                            icon={<FaPlus color="var(--color-p-300)"
                                          className="ops-icon-sm m-1 mx-3"/>}
                            variant="icon mx-1"
                            backgroundColor="bg-3 border border-1"
                            padding={false}
                            action={() => {
                                handleOpenModalArticle()
                            }}
                        />
                        {/*ZOBRAZIT AJ ZMAZANE*/}
                        <OpsBtn
                            id="tbl-filter-deleted"
                            tooltipText="Zobraziť zmazané články"
                            icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}
                                            className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowDeleted(!showDeleted)
                                getArticles(!showDeleted)
                            }}
                        />
                    </div>
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="concerts"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Názov",
                            selector: row => row.title,
                            sortable: true,
                            width: '30%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.title}
                                />
                            )
                        },
                        {
                            name: "Podnázov",
                            selector: row => row.subtitle,
                            sortable: false,
                            width: '30%',
                            cell: (row) => (
                                <OpsText
                                    type="label8" alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.subtitle}
                                />
                            )
                        },
                        {
                            name: "Videné",
                            selector: row => row.views,
                            sortable: false,
                            width: '10%',
                            center: true,
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.views}
                                />
                            )
                        },
                        {
                            name: "",
                            selector: row => row.published,
                            sortable: false,
                            width: '5%',
                            center: true,
                            cell: (row) =>
                                <OpsIconStatus
                                    status={row.published === true ? 'completed' : ''}/>
                        },
                        {
                            name: "Vytvorený",
                            selector: row => new Date(row.createdAt).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${new Date(row.createdAt).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.createdAt).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '10%',
                            cell: (row) => [
                                !row.deleted && <OpsBtn
                                    key={0}
                                    icon={<BiSolidEdit className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={row.deleted ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => handleOpenModalArticle(row)}
                                />,
                                row.deleted && <OpsBtn
                                    key={1}
                                    icon={<TbRestore className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor="bg-g-2"
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Obnovenie článku",
                                            `Naozaj si prajete obnoviť článok?`,
                                            theme,
                                            () => restoreArticle(row._id),
                                            () => null
                                        )
                                    }}
                                />,
                                !row.deleted && <OpsBtn
                                    key={2}
                                    icon={<BiShow className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={!row.published ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Zverejnenie článku",
                                            `Naozaj si prajete ${row.published ? 'zrušiť uverejnenie článku' : 'uverejniť článok'}?`,
                                            theme,
                                            () => patchArticle(row._id, {published: !row.published}),
                                            () => null
                                        )

                                    }}
                                />
                            ]
                        }
                    ]}
                    data={loading === false ? articles : []}
                />
            </div>
        </div>
    )
}

export default AdminArticles;